import Api from '@/services/api'

export default {
  getBenchmarkData (fieldId, params) {
    return Api().get(`/fields/${fieldId}/benchmark-chartjs`, { params });
  }
}
